import { render, staticRenderFns } from "./TractLandowners.vue?vue&type=template&id=09aafb2f&"
import script from "./TractLandowners.vue?vue&type=script&lang=js&"
export * from "./TractLandowners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports